import React, { useState } from 'react';

import CustomDatePicker from '@components/common/CustomDatePicker/CustomDatePicker';
import Input from '@components/common/Formik/FormikInputField';
import InputErrorMessage from '@components/common/Formik/InputErrorMessage/InputErrorMessage';
import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import Text from '@components/common/Text/Text';
import { potType } from '@propTypes/potTypes';

import css from './ObjectiveForm.module.scss';

type ObjectiveFormProps = {
    personRole: string;
    pot: potType;
    handleDateChange: (name: string, val: string) => void;
    handleAmountChange: (val: number) => void;
    isEditing: boolean;
    onToggleForm: (boolean) => void;
    onSetEditing: (boolean) => void;
    isObjectiveCompleted?: boolean;
    potRef: string;
    isOffered: boolean;
};

const ObjectiveForm = ({ handleAmountChange, handleDateChange, isObjectiveCompleted, pot }: ObjectiveFormProps) => {
    const { t } = useTranslateLpc(['lpc-pot', 'common', 'lpc-create-pot']);
    const [defaultDateLimit, setDefaultDateLimit] = useState<Date | string>(pot.poolObjective.dateLimit);
    const [limitExceeded, setLimitExceeded] = useState<boolean>(false);
    const now = new Date().getUTCFullYear();
    const years = Array(5)
        .fill('')
        .map((_, index) => now + index);

    const renderForm = () => {
        return (
            <>
                <div className={css.form}>
                    <div className={css.form__input}>
                        <CustomDatePicker
                            years={years}
                            name="dateLimit"
                            handleDateChange={(name, value) => {
                                handleDateChange(name, value);
                                setDefaultDateLimit(value);
                            }}
                            label={t('amount.objective.deadline-label')}
                            placeholder={t('form.event-date-placeholder')}
                            value={defaultDateLimit}
                            minDate={new Date()}
                            customLabelClassName={css.form__input__label}
                        />
                    </div>
                    <div className={`${css.form__input} ${css.form__input__amount}`}>
                        <Input
                            onHandleChange={(e) => {
                                handleAmountChange(e.target.value);
                                setLimitExceeded(e.target.value > 9999999);
                            }}
                            name="amountToReach"
                            type="number"
                            label={t('amount.objective.amount-to-reach-label')}
                            placeholder={t('amount.objective.amount-to-reach-placeholder')}
                            isAmount
                            customStyle={limitExceeded && 'required_field'}
                            customLabelStyle={css.form__input__label}
                        />
                        {limitExceeded && <InputErrorMessage name={'amountToReach'} messageCode={'MAX_objective'} />}
                    </div>
                </div>
            </>
        );
    };

    return (
        <>
            <div className={css.title}>
                <Text variant={'mini_label'} color={'txt-primary'}>
                    {!isObjectiveCompleted ? t('amount.objective.title') : t('amount.objective.title-completed')}
                </Text>
            </div>
            {renderForm()}
        </>
    );
};
export default ObjectiveForm;
